import { makeStyles } from '@material-ui/core/styles';
import { Turnstile } from '@marsidev/react-turnstile';
import { FC } from 'react';

const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY || '';

export interface TurnstileWidgetProps {
  remountKey?: number;
  onSuccess: (token: string) => void;
  onError?: () => void;
  onExpire?: () => void;
  error?: string | null;
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 8,
    width: '100%',
  },
  error: {
    fontFamily: "'Open Sans', sans-serif",
    fontSize: 12,
    color: '#d32f2f',
  },
});

const TurnstileWidget: FC<TurnstileWidgetProps> = ({
  remountKey = 0,
  onSuccess,
  onError,
  onExpire,
  error,
}) => {
  const classes = useStyles();

  if (!siteKey) {
    return (
      <div className={classes.root}>
        <span className={classes.error}>
          Configuration Turnstile manquante (REACT_APP_TURNSTILE_SITE_KEY).
        </span>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <Turnstile
        key={remountKey}
        siteKey={siteKey}
        onSuccess={onSuccess}
        onError={onError}
        onExpire={onExpire}
        options={{ appearance: 'interaction-only' }}
      />
      {error ? <span className={classes.error}>{error}</span> : null}
    </div>
  );
};

export default TurnstileWidget;
